import Quill from 'quill'

// Override default block tag from <p> to <div>
const Block = Quill.import('blots/block')
Block.tagName = 'div'
Quill.register(Block, true)